import { type BlockViewProps } from '@plone/types';
import MenuDesktop from './menudesktop';
import MenuMobile from './menumobile';
import { useMediaQuery } from 'usehooks-ts';

export interface PageTitleWithMenuData {
  '@type': 'pagetitlewithmenu';
  placeholder?: string;
}

type Props = BlockViewProps & {
  data: PageTitleWithMenuData;
};

const ViewPageTitleWithMenuBlock = ({ properties, metadata }: Props) => {
  const items = (properties?.items || []).filter(
    (item) => !item.exclude_from_nav,
  );
  const isMobile = useMediaQuery('(max-width: 1199px)');
  return isMobile ? (
    <MenuMobile items={items} id={properties['@id']} title={properties.title} />
  ) : (
    <MenuDesktop items={items} isEditMode={false} title={properties.title} />
  );
};

export default ViewPageTitleWithMenuBlock;
